module.exports = __webpack_public_path__ + "img/law_thumbnail-600x450.a826dfa7.jpg";